const config = {"region":"eu-central-1","apiUrl":"https://6n7no88vr0.execute-api.eu-central-1.amazonaws.com/","userPoolId":"eu-central-1_OF9ssS2vu","userPoolWebClientId":"5eqs9i3sd82u2jvllp3m5kirur","authenticationFlowType":"USER_PASSWORD_AUTH"};

export default config;

